@let toggle = $toggle();
@let state = $state();

<div class="inline-nav-shell" role="navigation" aria-label="Primary">

    <div class="inline-nav-brand" (click)="actions.toggleNav()">

        <img [src]="toggle ? '/images/workbuddy_full_logo_blue_transparent.svg' : '/images/workbuddy-logo.svg'"
             alt="WorkBuddy"
             class="inline-nav-logo"
             [class.inline-nav-logo-full]="toggle"
             [class.inline-nav-logo-mark]="!toggle" />

        @if (plan) {
            <div class="inline-nav-plan-chip">{{ plan }}</div>
        }

    </div>

    <div class="inline-nav-modules" cdk-scrollable data-cy="inline-nav-modules">

        <cdk-accordion [multi]="true">

            @for (route of $primaryRoutes(); track route.path) {

                @if (hasChildren(route)) {

                    <inline-sidenav-group [route]="route" [expanded]="toggle" />

                } @else {

                    <a class="inline-nav-row"
                       routerLink="/{{ route.path }}"
                       routerLinkActive="active"
                       [attr.aria-label]="route.data?.title"
                       [title]="!toggle ? $safeNavigationMigration(route.data?.title) : null">

                        <span class="inline-nav-row-icon">
                            @if (route.data?.icon) { <i class="fa" [ngClass]="route.data.icon"></i> }
                        </span>
                        <span class="inline-nav-row-label">{{ route.data?.title }}</span>

                    </a>
                }
            }
        </cdk-accordion>
    </div>

    <div class="inline-nav-uploader-hidden">
        <uploader-centre [tenantId]="$safeNavigationMigration(state?.user?.tenantUrl)" [token]="$safeNavigationMigration(state?.token)" [signingEndpoint]="signingEndpoint" [successEndpoint]="successEndpoint" />
    </div>

    <div class="inline-nav-footer">

        <div class="inline-nav-divider-line"></div>

        @if ($inboxRoute(); as inbox) {
            <a class="inline-nav-row inline-nav-row-with-badge"
               routerLink="/{{ inbox.path }}"
               routerLinkActive="active"
               [attr.aria-label]="inbox.data?.title"
               [title]="!toggle ? $safeNavigationMigration(inbox.data?.title) : null">
                <span class="inline-nav-row-icon">
                    @if (inbox.data?.icon) { <i class="fa" [ngClass]="inbox.data.icon"></i> }
                    @if (!toggle && inboxBadgeService.$attentionCount() > 0) {
                        <span class="inline-nav-rail-badge">{{ inboxBadgeService.$displayCount() }}</span>
                    }
                </span>
                <span class="inline-nav-row-label">{{ inbox.data?.title }}</span>
                @if (toggle && inboxBadgeService.$attentionCount() > 0) {
                    <span class="inline-nav-row-badge" [class.plus]="inboxBadgeService.$displayCount().includes('+')">{{ inboxBadgeService.$displayCount() }}</span>
                }
            </a>
        }

        @if ($aiAssistantRoute(); as ai) {
            <a class="inline-nav-row"
               routerLink="/{{ ai.path }}"
               routerLinkActive="active"
               [attr.aria-label]="ai.data?.title"
               [title]="!toggle ? $safeNavigationMigration(ai.data?.title) : null">
                <span class="inline-nav-row-icon">
                    @if (ai.data?.icon) { <i class="fa" [ngClass]="ai.data.icon"></i> }
                </span>
                <span class="inline-nav-row-label">{{ ai.data?.title }}</span>
            </a>
        }

        @if ($agentRoute(); as agent) {
            <a class="inline-nav-row"
               routerLink="/{{ agent.path }}"
               routerLinkActive="active"
               [attr.aria-label]="agent.data?.title"
               [title]="!toggle ? $safeNavigationMigration(agent.data?.title) : null">
                <span class="inline-nav-row-icon">
                    @if (agent.data?.icon) { <i class="fa" [ngClass]="agent.data.icon"></i> }
                </span>
                <span class="inline-nav-row-label">{{ agent.data?.title }}</span>
            </a>
        }

        @if ($settingsRoute(); as settings) {
            <a class="inline-nav-row"
               routerLink="/{{ settings.path }}"
               routerLinkActive="active"
               [attr.aria-label]="settings.data?.title"
               [title]="!toggle ? $safeNavigationMigration(settings.data?.title) : null">
                <span class="inline-nav-row-icon">
                    @if (settings.data?.icon) { <i class="fa" [ngClass]="settings.data.icon"></i> }
                </span>
                <span class="inline-nav-row-label">{{ settings.data?.title }}</span>
            </a>
        }

        <help-nav [navExpanded]="toggle" />
        <user-nav [accountUrl]="accountUrl" [state]="state" (logout)="onLogout()" />

    </div>

    @if (buildVersion) {
        <div class="inline-nav-build-version">{{ buildVersion }}</div>
    }

</div>
